import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAirplane = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M21.6 14.157L14.479 9.41002C13.686 8.88102 12.63 8.98602 11.955 9.66002L9.57898 12.036L18.064 17.693",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.843 18.4L30.59 25.521C31.119 26.314 31.014 27.37 30.34 28.045L27.964 30.421L22.307 21.936",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.401 23.341L9.07899 23.003C8.15299 22.932 7.63899 24.051 8.29499 24.707L10.9 27.293L13.401 23.341Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.659 26.599L16.997 30.921C17.068 31.847 15.949 32.361 15.293 31.705L12.707 29.1L16.659 26.599Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.343 24.899L11.521 29.851C10.628 30.387 9.61299 29.372 10.149 28.479L15.101 20.657L24.879 10.879C26.051 9.707 27.95 9.707 29.122 10.879C30.294 12.051 30.294 13.95 29.122 15.122L19.343 24.899Z",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "square"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white",
			transform: "translate(8 8)"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgAirplane);
export default ForwardRef;
